import { render, staticRenderFns } from "./trash-quiz.html?vue&type=template&id=501f9345&scoped=true&"
import script from "./trash-quiz.js?vue&type=script&lang=js&"
export * from "./trash-quiz.js?vue&type=script&lang=js&"
import style0 from "./trash-quiz.scss?vue&type=style&index=0&id=501f9345&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501f9345",
  null
  
)

export default component.exports